import React from "react";
import PropTypes from "prop-types";
import DispatchModalList from "./DispatchModalList";

const DispatchTrucksList = ({
  toolboxes,
  trucks,
  handleUpdateModalState,
  selectedTrucks,
  occupiedTrucks
}) => {
  const columns = [{ selector: "name", title: "Camions", type: "string" }];

  const MAX_VCS = 6;

  function handleItemClick(item) {
    let newTrucks = [...selectedTrucks];
    if (selectedTrucks.find(truckID => truckID === item.id)) {
      newTrucks = newTrucks.filter(truckID => truckID !== item.id);
    } else if (toolboxes.length + selectedTrucks.length < MAX_VCS) {
      newTrucks.push(item.id);
    }

    handleUpdateModalState({ trucks: newTrucks });
  }

  return (
    <DispatchModalList
      data={trucks}
      selected={selectedTrucks}
      columns={columns}
      onClick={handleItemClick}
      highlighted={occupiedTrucks}
    />
  );
};

DispatchTrucksList.propTypes = {
  trucks: PropTypes.array,
  handleUpdateModalState: PropTypes.func,
  selectedTrucks: PropTypes.array
};

export default DispatchTrucksList;
